import AddUserIcon from "@assets/SvgComponents/AddUserIcon";
import AdminIcon from "@assets/SvgComponents/AdminIcon";
import ClientIcon from "@assets/SvgComponents/ClientIcon";
import EyeIcon from "@assets/SvgComponents/EyeIcon";
import FilterTableHead from "@assets/SvgComponents/FilterTableHead";
import SearchIcon from "@assets/SvgComponents/SearchIcon";
import CheckboxCustom from "@components/CheckboxCustom";
import InputCustom from "@components/InputCustom";
import LinearLoading from "@components/LinearLoading";
import PaginationCustom from "@components/PaginationCustom";
import { PaperShadowCustom } from "@components/PaperCustom";
import SelectCustom from "@components/SelectCustom";
import Spacing from "@components/Spacing";
import {
  Box,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { IAppState } from "@stores/state";
import { getUsers } from "@stores/users/users.creator";
import { IFilterUsersDto, RoleName } from "@stores/users/users.dto";
import { Colors } from "@themes/colors";
import { TextStyles } from "@themes/textStyles";
import { convertFormatPhone } from "@utils/convertFormatPhone";
import { formatCustomInput } from "@utils/formatCustomInput";
import { notistack } from "@utils/notistack";
import * as _ from "lodash";
import { debounce } from "lodash";
import React, { ChangeEvent, useCallback, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ActionsUser from "./ActionsUser";
import BoxUsername from "./BoxUsername";

const dataSelect = [
  { value: "Fake Value 1", label: "Fake Value 1" },
  { value: "Fake Value 2", label: "Fake Value 2" },
  { value: "Fake Value 3", label: "Fake Value 3" },
  { value: "Fake Value 4", label: "Fake Value 4" },
];

const dataSelectRole = [
  { value: null, label: "Tous" },
  { value: RoleName.admin, label: "Administrateur" },
  { value: RoleName.user, label: "Utilisateur" },
  { value: RoleName.client, label: "Client" },
];

const dataPage = [
  { value: 5, label: "05" },
  { value: 10, label: "10" },
  { value: 15, label: "15" },
  { value: 20, label: "20" },
];

interface Filters {
  role?: RoleName;
}

const ListUsers = () => {
  const textStyles = TextStyles();
  const classes = useStyles();
  const dispatch = useDispatch();

  const [page, setPage] = React.useState<number>(1);
  const [rowsPerPage, setRowsPerPage] = React.useState<number>(5);
  const [sortName, setSortName] = useState<boolean | undefined>(undefined);
  const [valueSearch, setValueSearch] = useState<any>();
  const [filters, setFilters] = useState<Filters>({});

  const { loadingGet, dataUsers, error, message, loadingDelete } = useSelector(
    (state: IAppState) => state?.users
  );

  const { control } = useForm();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceSearch = useCallback(
    debounce((nextValue) => {
      setValueSearch(nextValue);
      setPage(1);
    }, 500),
    []
  );

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    debounceSearch(e.target.value);
  };

  const handleChangeRowsPerPage = (value: number) => {
    setRowsPerPage(value);
    setPage(1);
  };

  const handleGetUserList = useCallback(() => {
    const filterUserDto: IFilterUsersDto = {
      page,
      limit: rowsPerPage,
      name: valueSearch,
      // ...filters,
    };

    if (sortName !== undefined) {
      filterUserDto.sortBy = { name: sortName ? 1 : -1 };
    }

    dispatch(getUsers(filterUserDto));
  }, [
    dispatch,
    // filters,
    page,
    rowsPerPage,
    sortName,
    valueSearch,
  ]);

  // Fetch users when filter change
  useEffect(() => {
    handleGetUserList();
  }, [handleGetUserList]);

  // Notifies
  useEffect(() => {
    error && notistack.error(error);
    message && notistack.success(message);
  }, [error, message]);

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography sx={{ pt: 2, pb: 4 }} className={textStyles.h3}>
          Gérer les utilisateurs
        </Typography>

        <PaperShadowCustom>
          <Box>
            <Stack
              sx={{
                px: 3,
                py: 3.5,
                borderBottom: "1px solid #EBE9F1",
              }}
              spacing={2}
            >
              <Grid item xs={12}>
                <Typography className={textStyles.h4}>
                  Chercher et filtrer
                </Typography>
              </Grid>

              <Grid item xs={12} display="flex">
                <Grid item xs={12} sm={6} md={4} sx={{ mr: 2 }}>
                  <Box component="div">
                    <Typography
                      className={textStyles.paragraph_small_500}
                      sx={{ mb: 0.5 }}
                    >
                      Nom
                    </Typography>
                    <Controller
                      control={control}
                      name="nom_select"
                      render={({ field: { onChange, value } }) => (
                        <SelectCustom
                          data={dataSelect}
                          placeholder="Nom"
                          onChange={onChange}
                          defaultValue={value}
                        />
                      )}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Box component="div">
                    <Typography
                      className={textStyles.paragraph_small_500}
                      sx={{ mb: 0.5 }}
                    >
                      Role
                    </Typography>
                    <Controller
                      control={control}
                      name="role_select"
                      render={({ field: { onChange, value } }) => (
                        <SelectCustom
                          // data={dataSelectRole}
                          data={dataSelect}
                          placeholder="Active"
                          onChange={(e) => {
                            onChange(e);
                            setPage(1);
                            setFilters((prevFilters) => ({
                              ...prevFilters,
                              role: e,
                            }));
                          }}
                          defaultValue={value}
                        />
                      )}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Stack>

            <Box
              component="div"
              display="flex"
              sx={{ px: 3, pt: 2.5, pb: 2.5, position: "relative" }}
              justifyContent="space-between"
              alignItems="center"
            >
              {loadingGet && <LinearLoading />}
              <Box
                component="div"
                display="flex"
                alignItems="center"
                width="70%"
              >
                <Typography className={textStyles.paragraph}>
                  Afficher
                </Typography>
                <Spacing width={5} />

                <Box component="div" width={60}>
                  <SelectCustom
                    onChange={(value: number) => {
                      if (typeof value === "number") {
                        handleChangeRowsPerPage(value);
                      }
                    }}
                    data={dataPage}
                    defaultValue={5}
                    border={false}
                  />
                </Box>
                <Spacing width={30} />

                <Controller
                  name="name"
                  control={control}
                  render={({ field: { value, onChange } }) => (
                    <InputCustom
                      placeholder="Rechercher"
                      endAdornmentIcon={<SearchIcon color="#BABFC7" />}
                      value={value}
                      onChange={(e) => {
                        onChange(e);
                        handleSearch(e);
                      }}
                    />
                  )}
                />
              </Box>

              <Box
                display="flex"
                alignItems="flex-end"
                width="fit-content"
                justifyContent="flex-end"
                sx={{ cursor: "pointer", textDecoration: "none" }}
              >
                <Link
                  to="/management-users/information-detail"
                  style={{ display: "flex", alignItems: "flex-end" }}
                >
                  <AddUserIcon color={Colors.primary} />
                  <Typography
                    className={textStyles.paragraph_bold}
                    sx={{
                      color: Colors.primary,
                      textDecoration: "underline",
                      ml: 1,
                    }}
                  >
                    Créer un utilisateur
                  </Typography>
                </Link>
              </Box>
            </Box>

            <Table>
              <TableHead>
                <TableRow className={classes.tableHead}>
                  <TableCell sx={{ width: "3%" }}>
                    <Box
                      component="div"
                      display="flex"
                      alignItems="center"
                      justifyContent="flex-end"
                    >
                      <CheckboxCustom onChange={() => console.log("test")} />
                    </Box>
                  </TableCell>
                  <TableCell sx={{ width: "22%", pl: "10px !important" }}>
                    <Box
                      component="div"
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      sx={{ cursor: "pointer" }}
                      onClick={() => setSortName(!sortName)}
                    >
                      <Typography
                        className={textStyles.paragraph_small_semi_bold}
                      >
                        NOM
                      </Typography>
                      <FilterTableHead />
                    </Box>
                  </TableCell>
                  <TableCell sx={{ width: "15%" }}>
                    <Typography
                      className={textStyles.paragraph_small_semi_bold}
                    >
                      TELEPHONE
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ width: "15%" }}>
                    <Box
                      component="div"
                      display="flex"
                      alignItems="center"
                      sx={{ cursor: "pointer" }}
                      justifyContent="space-between"
                    >
                      <Typography
                        className={textStyles.paragraph_small_semi_bold}
                      >
                        ROLE
                      </Typography>
                      <FilterTableHead />
                    </Box>
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      pl: "0 !important",
                      width: "45%",
                      pr: "50px !important",
                    }}
                  >
                    <Typography
                      className={textStyles.paragraph_small_semi_bold}
                    >
                      ACTIONS
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {_.isArray(dataUsers?.data) &&
                  dataUsers?.data.map((user, index: number) => (
                    <TableRow className={classes.rowBody} key={index}>
                      <TableCell sx={{ width: "3%", pr: 0 }}>
                        <Box
                          component="div"
                          display="flex"
                          alignItems="center"
                          justifyContent="flex-end"
                        >
                          <CheckboxCustom
                            onChange={() => console.log("test")}
                          />
                        </Box>
                      </TableCell>
                      <TableCell sx={{ width: "22%", pl: "10px !important" }}>
                        <BoxUsername
                          name={user?.email || ""}
                          email={user?.email}
                        />
                      </TableCell>
                      <TableCell sx={{ width: "15%" }}>
                        <Typography className={textStyles.paragraph}>
                          {user?.phoneNumber &&
                            formatCustomInput(
                              convertFormatPhone(user?.phoneNumber),
                              "phone"
                            )}
                        </Typography>
                      </TableCell>
                      <TableCell sx={{ width: "15%" }}>
                        <Box component="div" display="flex" alignItems="center">
                          {user?.roles[0]?.name === "Admin" ? (
                            <AdminIcon color="#EA5455" />
                          ) : user?.roles[0]?.name === "User" ? (
                            <EyeIcon color="#28C76F" />
                          ) : (
                            <ClientIcon color="#FFDB5C" />
                          )}
                          <Typography
                            className={textStyles.paragraph_semi_bold}
                            sx={{ ml: 1.5 }}
                          >
                            {user?.roles[0]?.name === "Admin"
                              ? "Administrateur"
                              : user?.roles[0]?.name === "User"
                              ? "Utilisateur"
                              : "Client"}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          pl: "0 !important",
                          pr: "62px !important",
                          width: "45%",
                        }}
                      >
                        <Box
                          component="div"
                          display="flex"
                          alignItems="center"
                          justifyContent="flex-end"
                        >
                          <ActionsUser id={user._id} loading={loadingDelete} />
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>

            <Box
              component="div"
              display="flex"
              alignItems="flex-end"
              justifyContent="space-between"
              sx={{ mx: 3, py: 2.5 }}
            >
              <Typography
                className={textStyles.paragraph}
                sx={{ color: "#B9B9C3" }}
              >
                {dataUsers?.data?.length} éléments affichés sur{" "}
                {dataUsers?.total}
              </Typography>
              <PaginationCustom
                page={dataUsers?.page ? dataUsers.page : 1}
                onChange={(_, page: number) => setPage(page)}
                count={dataUsers?.last_page}
              />
            </Box>
          </Box>
        </PaperShadowCustom>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles({
  tableHead: {
    background: "#F3F2F7",
    borderTop: "1px solid #EFEDF4",
    "& .MuiTableCell-head": {
      padding: "8px 0 8px 25px",
      "& .MuiTypography-root": {
        color: "#5E5873",
      },
      borderBottom: "1px solid #EFEDF4",
    },
  },
  rowBody: {
    "& .MuiTableCell-root": {
      paddingLeft: "25px",
      "& .MuiTypography-root": {
        color: "#5E5873",
      },
      borderBottom: "1px solid #EFEDF4",
    },
  },
});

export default ListUsers;
